export default "__VITE_ASSET__JumedKIp__"